import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Router from 'next/router'

import classnames from 'classnames'
import store from 'services/store'
import { Row, Col } from 'flexbox'
import { OCUPATION_STATUS, seoTitleWithAddress, STATUS_LABEL } from 'services/seo'
import { PdfActionCreators } from 'app/reducers/PdfDownloadRedux'
import { ContactJourneyCreators } from 'app/reducers/ContactJourneyRedux'
import { getAnalyticActionTrackerLink } from 'components/Vip/linkConfig'

import {Button, IonIcon } from 'controls'
import { Card } from 'components'
import Breadcrumb from 'components/Srp/getBreadcrumb'
import NavigationPropertyFooter from 'components/Footer/NavigationPropertyFooter'
import ConnectedForm from 'components/Forms/VipContactForm/ConnectedForm'
import Brochure from 'components/Brochure'
import Panel from 'components/Panel'
import { companyConfig } from 'globalConfigApp'

import Video from './Video'
import Header from './SimpleHeader'
import Gallery from './SeoGallery'
import Amenities from './Amenities'
import Blueprints from './Blueprints'
import Description from './Description'
import Specifications from './Specifications'
import TagOcupationStatus from './TagOcupationStatus'

import vip, { panelTitles } from './styles'

class Vip extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      openModal : false
    }
  }

  componentDidMount() {
    this.props.actions.cleanStatePdf()
    setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }), 0)
  }

  componentWillUnmount() {
    this.props.actions.cleanStatePdf()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const p = prevProps.sendContactRequest
    const n = this.props.sendContactRequest

    if (p.loading && !n.loading && !p.response && n.response && !n.error) {
      this.handleRequestPropertyInfo()
    }
  }
  openShareVirtualTourModal = () => this.setState({openModal: true})
  closeModal = () => this.setState({openModal: false})
  getVideo = () => {
    const { videoUrl } = this.props.property
    if (!videoUrl) {
      return null
    }
    return (
      <Panel title={<h2 className="panel-title">Video</h2>} className="form-input-margin">
        <Video videoUrl={videoUrl} />
        <style jsx>{panelTitles}</style>
      </Panel>
    )
  }

  getAmenities = () => {
    const { amenities } = this.props.property
    if (amenities.length === 0) {
      return null
    }
    return (
      <Panel title={<h2 className="panel-title">Amenidades</h2>} className="form-input-margin">
        <Amenities amenities={amenities} />
        <style jsx>{panelTitles}</style>
      </Panel>
    )
  }

  getBlueprints = () => {
    const { property } = this.props
    const blueprints = property.imagesJson.filter(
      ij => ij.imageType === 'BLUEPRINT'
    )
    if (blueprints.length === 0) {
      return null
    }
    return (
      <Panel title={<h2 className="panel-title">Planos</h2>} className="form-input-margin">
        <Blueprints property={property} />
        <style jsx>{panelTitles}</style>
      </Panel>
    )
  }

  getSocials = () => {
    const {
      loading,
      success,
      error,
      messageError,
      property,
      actions
    } = this.props
    const propertyId = property.id

    return (
      <Panel>
        <Row>
          <Col xs={4} md={2}>
            <Brochure property={property} type="VIP" withBrokerInfo>
              <Button
                outline
                fullWidth
                color="primary"
                loading={loading}
                onClick={() => {
                  actions.sendGTEvent('vip-public', 'get-brochure', {
                    propertyId
                  })
                  this.handleDownloadBrochure()
                }}
              >
                Ver folleto
              </Button>
            </Brochure>
          </Col>
          {error && (
            <Col xs={8} md={10}>
              <p>
                Tuvimos un contratiempo con la generación de su PDF: "
                {messageError}"
              </p>
            </Col>
          )}
        </Row>
      </Panel>
    )
  }

  handleRequestPhone = () =>
    this.changeAnalyticActionRoute('BROKER_TELEPHONE_REQUESTED')

  handleRequestPropertyInfo = () =>
    this.changeAnalyticActionRoute('PROPERTY_INFO_REQUESTED')

  handleSubmitReport = () =>
    this.changeAnalyticActionRoute('PROPERTY_REPORTED')
  
  handleDownloadBrochure = () =>
    this.changeAnalyticActionRoute('PDF_DOWNLOADED')

  changeAnalyticActionRoute = (analyticAction) => {
    if (this.props.isPrivate) {
      return
    }
    const analyticActionTrackerLink = getAnalyticActionTrackerLink(
      this.props.property,
      analyticAction
    )

    Router.push(
      analyticActionTrackerLink.href,
      analyticActionTrackerLink.as,
      { shallow: true }
    )
  }

  render() {
    const { property, sendContactRequest, isPrivate=false } = this.props
    const { property: { brokerData: { isExternal } } } = this.props
    const {
      brokerData,
      description,
      id,
      operationType,
      propertyType,
      title,
      state,
      district,
      neighborhood,
      postalCode,
      status,
      url: propertyUrl,
      imagesJson,
    } = property

    const { vipAsideLinks } = this.props

    const isClosed = status === 'ARCHIVED'

    const findCurrentOcupationStatus =
      isClosed && OCUPATION_STATUS.find(({ value }) => value === operationType)

    const statusLabel = isClosed
      ? findCurrentOcupationStatus
      : STATUS_LABEL.find(({ value }) => value === status)

    const externalPartner = brokerData.lastName || "Externo"
    const externalLabel = brokerData.isExternal ? externalPartner : ""

    return (
      <Fragment>
        {!isPrivate && (
          <div className="vip-breadcrumb-header">
            <div className="container">
              <Breadcrumb
                showGoBackToSearchesButton
                filters={{
                  operationType,
                  propertyType,
                  selectedLocations: [
                    `${postalCode}::${neighborhood}::${district}::${state}`
                  ]
                }}
              />
            </div>
          </div>
        )}

        <section className="vip">
          <div>
            <section
              className={classnames('vip-content', {
                'without-side-bar': !brokerData || isPrivate,
                'only-one-image-gallery': imagesJson.length === 1
              })}
            >
              <Header
                property={property}
                className="vip-header"
              />

              <TagOcupationStatus status={statusLabel} />

              <Gallery
                currentOcupationStatus={statusLabel}
                imagesJson={this.props.property.imagesJson}
                lat={this.props.property.lat}
                lng={this.props.property.lng}
                imagesAlt={`${seoTitleWithAddress(property)} | NEX-${id} | ${companyConfig.name}`}
                className="vip-gallery-container"
                isExternal={isExternal}
                externalLabel={externalLabel}
              />

              <div
                className={classnames('vip-info', {
                  full: !brokerData || isPrivate
                })}
              >

                {brokerData && this.getSocials()}
                <Panel
                  title={<h2 className="panel-title">Especificaciones</h2>}
                  className="form-input-margin"
                >
                  <Specifications property={this.props.property} />
                </Panel>
                <Panel
                  title={<h2 className="panel-title">{title}</h2>}
                  className="form-input-margin"
                >
                  <Description
                    id={id}
                    description={description}
                    property={property}
                    operationType={operationType}
                    onSubmitReport={this.handleSubmitReport}
                  />
                </Panel>

                {this.getVideo()}
                {this.getBlueprints()}
                {this.getAmenities()}
              </div>
              {!isPrivate && brokerData &&(
                <aside className="vip-sidebar-content">
                  <ConnectedForm
                    propertyId={id}
                    brokerData={brokerData}
                    propertyUrl={propertyUrl}
                    handleRequestPhone={this.handleRequestPhone}
                    currentOcupationStatus={findCurrentOcupationStatus}
                    errorMessageForm={
                      sendContactRequest.error &&
                      'Hubo un error, por favor verífica tus datos o intenta más tarde'
                    }
                  />

                  {vipAsideLinks.length > 0 && (
                    <Card alignLeft bordered>
                      <NavigationPropertyFooter
                        orientation={'vertical'}
                        categories={vipAsideLinks}
                      />
                    </Card>
                  )}
                </aside>
              )}
            </section>
          </div>
        </section>
        <style jsx>{vip}</style>
        <style jsx>{panelTitles}</style>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  ...state.pdfDownload,
  vipAsideLinks: state.vip.vipAsideLinks,
  sendContactRequest: store.vipContact('property').selector(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getBrochure: PdfActionCreators.getPdfRequest,
      cleanStatePdf: PdfActionCreators.cleanState,
      sendGTEvent: ContactJourneyCreators.sendGTEvent
    },
    dispatch
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Vip)
